/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConditionBuilder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M14 21H2v-6h12zM4 19h8v-2H4zm16-2h2v2h-2v2h-2v-2h-2v-2h2v-2h2zm-10-4H2v-2h8zm4-4H2V3h12zM4 7h8V5H4zm16-2h2v2h-2v2h-2V7h-2V5h2V3h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgConditionBuilder as ConditionBuilder };
